/* eslint-disable react-hooks/exhaustive-deps */
import { Accordion, AccordionDetails, AccordionSummary, Button, createStyles, Grid, makeStyles, TextField, Theme, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FormApi } from 'final-form';
import gql from 'graphql-tag';
import React, { useState } from 'react';
import { useMutation } from 'react-apollo';
import { AnyObject, Field, Form, FormSpy } from 'react-final-form';
import { showNotification } from '../../App';
import { RvLoader } from '../../components/Loader';
import { LabelSettings } from '../ApplicationSettingsRepository';
import { LocalStorageEnum } from '../../enums/LocalStorageEnum';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flex: 1,
            flexFlow: 'column',
        },
        accordionPanel: {
            boxShadow: '0 1px 6px rgba(0,0,0,0.14)',
        },
        textField: {
            width: '100%'
        },
        buttonWrapper: {
            margin: '0 -10px',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            '& > button': {
                margin: '0 10px',
            }
        },
        loaderWrapper: {
            display: 'flex',
            justifyContent: 'center',
            flex: 1,
        },
        formGroup: {
            alignItems: 'flex-start',
            '& .MuiFormControlLabel-root': {
                marginLeft: 0,
            }
        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
            fontWeight: 600,
            color: theme.palette.primary.main,
        },
        accordionDetails: {
            flexFlow: 'column',
        },
    })
);

interface FormState {
    personActingLabel: string | null | undefined;
    personResponsibleLabel: string | null | undefined;
    matterAssistingResponsibilityLabel: string | null | undefined;
    matterIntroducingResponsibilityLabel: string | null | undefined;
    matterWorkingResponsibilityMapping: string | null | undefined;
    matterOversightResponsibilityMapping: string | null | undefined;
    matterAssistingResponsibilityMapping: string | null | undefined;
    matterIntroducerResponsibilityMapping: string | null | undefined;
}
interface LabelSettingsTabState {
    isLoading: boolean;
    isFormChanged: boolean;
    onSubmitLoading: boolean;
}

interface LabelSettingsTabProps {
    data: LabelSettings | null;
    onSave?: (data: LabelSettings | null) => void;
}

export default function LabelSettingsTab(props: LabelSettingsTabProps) {

    const classes = useStyles();

    const [state, setState] = useState<LabelSettingsTabState>({
        isLoading: false,
        isFormChanged: false,
        onSubmitLoading: false,
    });

    const [formState] = useState<FormState>({
        personActingLabel: props.data?.config.personActingLabel,
        personResponsibleLabel: props.data?.config.personResponsibleLabel,
        matterAssistingResponsibilityLabel: props.data?.config.matterAssistingResponsibilityLabel,
        matterIntroducingResponsibilityLabel: props.data?.config.matterIntroducingResponsibilityLabel,
        matterWorkingResponsibilityMapping: props.data?.config.matterWorkingResponsibilityMapping,
        matterOversightResponsibilityMapping: props.data?.config.matterOversightResponsibilityMapping,
        matterAssistingResponsibilityMapping: props.data?.config.matterAssistingResponsibilityMapping,
        matterIntroducerResponsibilityMapping: props.data?.config.matterIntroducerResponsibilityMapping,
    });

    // tslint:disable-next-line: no-any
    const [updateLabelSettings] = useMutation<any, LabelSettingsMutationParams>(LabelSettingsMutation);

    // tslint:disable-next-line: no-any
    const onFormValueChanged = (changeProps: any) => {
        if (!changeProps.pristine) {
            setState((prevState) => {
                return {
                    ...prevState,
                    isFormChanged: true
                };
            });
        }
    };

    // tslint:disable-next-line: no-any
    // const required = (value: any) => {
    //     return value ? undefined : 'Required';
    // };

    const onReset = (form: FormApi<FormState>) => () => {
        form.setConfig('keepDirtyOnReinitialize', false);
        form.batch(() => {
            form.reset();
        });
        form.setConfig('keepDirtyOnReinitialize', true);
    };

    const onSubmit = (form: FormApi<FormState>, values: AnyObject) => {
        // console.log('submit');
        setState((prevState) => {
            return {
                ...prevState,
                onSubmitLoading: true,
            };
        });

        updateLabelSettings({
            variables: {
                personActingLabel: values.personActingLabel ?? '', 
                personResponsibleLabel: values.personResponsibleLabel ?? '',
                matterAssistingResponsibilityLabel: values.matterAssistingResponsibilityLabel ?? '',
                matterIntroducingResponsibilityLabel: values.matterIntroducingResponsibilityLabel ?? '',
                matterWorkingResponsibilityMapping: values.matterWorkingResponsibilityMapping ?? '',
                matterOversightResponsibilityMapping: values.matterOversightResponsibilityMapping ?? '',
                matterAssistingResponsibilityMapping: values.matterAssistingResponsibilityMapping ?? '',
                matterIntroducerResponsibilityMapping: values.matterIntroducerResponsibilityMapping ?? '',
            }
        })
        // tslint:disable-next-line: no-any
        .then((results) => {
            if (results.data) {
                showNotification(null, 'Successfully submitted', 'info');     

                form.setConfig('keepDirtyOnReinitialize', false);

                localStorage.setItem(LocalStorageEnum.PersonResponsible, values.personResponsibleLabel ?? '');
                localStorage.setItem(LocalStorageEnum.PersonActing, values.personActingLabel ?? '');
                localStorage.setItem(LocalStorageEnum.MatterAssistingResponsibility, values.matterAssistingResponsibilityLabel ?? '');
                localStorage.setItem(LocalStorageEnum.MatterIntroducingResponsibility, values.matterIntroducingResponsibilityLabel ?? '');
                
                const tempInitial: FormState = {
                    personActingLabel: values.personActingLabel,
                    personResponsibleLabel: values.personResponsibleLabel,
                    matterAssistingResponsibilityLabel: values.matterAssistingResponsibilityLabel,
                    matterIntroducingResponsibilityLabel: values.matterIntroducingResponsibilityLabel,
                    matterWorkingResponsibilityMapping: values.matterWorkingResponsibilityMapping,
                    matterOversightResponsibilityMapping: values.matterOversightResponsibilityMapping,
                    matterAssistingResponsibilityMapping: values.matterAssistingResponsibilityMapping,
                    matterIntroducerResponsibilityMapping: values.matterIntroducerResponsibilityMapping,
                };

                form.batch(() => {
                    form.reset(tempInitial);
                });
                
                form.setConfig('keepDirtyOnReinitialize', true);

                setState((_prevState) => {
                    return {
                        ..._prevState,
                        onSubmitLoading: false,
                    };
                });

                if (props.onSave && props.data) {
                    const tempData = props.data;
                    tempData.config.personActingLabel = values.personActingLabel;
                    tempData.config.personResponsibleLabel = values.personResponsibleLabel;
                    tempData.config.matterAssistingResponsibilityLabel = values.matterAssistingResponsibilityLabel;
                    tempData.config.matterIntroducingResponsibilityLabel = values.matterIntroducingResponsibilityLabel;
                    tempData.config.matterWorkingResponsibilityMapping = values.matterWorkingResponsibilityMapping;
                    tempData.config.matterOversightResponsibilityMapping = values.matterOversightResponsibilityMapping;
                    tempData.config.matterAssistingResponsibilityMapping = values.matterAssistingResponsibilityMapping;
                    tempData.config.matterIntroducerResponsibilityMapping = values.matterIntroducerResponsibilityMapping;
                    props.onSave(tempData);
                } 
            }
        })
        // tslint:disable-next-line:no-any
        .catch((reason: any) => {
            showNotification('Failed to update application security settings', reason, 'error');
            setState((_prevState) => {
                return {
                    ..._prevState,
                    onSubmitLoading: false
                };
            });
        });
    };

    return (
        <div className={classes.root}>
            {state.isLoading ? (
                <div className={classes.loaderWrapper}>
                    <RvLoader />
                </div>
            ) : (
                <Form
                    onSubmit={(values, form: FormApi<FormState>) => onSubmit(form, values)}  
                    initialValues={formState}
                    initialValuesEqual={() => true}
                    keepDirtyOnReinitialize={true}
                    subscription={{
                        submitting: true,
                        pristine: true
                    }}
                    render={({
                        handleSubmit,
                        form,
                        submitting,
                        pristine,
                        values
                    }) => (
                            <form onSubmit={handleSubmit} id="securitytab">
                                <FormSpy 
                                    subscription={{ pristine: true }}
                                    // tslint:disable-next-line: no-shadowed-variable
                                    onChange={props => {
                                        onFormValueChanged(props);
                                    }}
                                />
                                
                                <Grid container={true} spacing={3}>
                                    <Grid item={true} xs={12} md={12}>
                                        <Accordion defaultExpanded={true} className={classes.accordionPanel}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="label-settings-panel">
                                                <Typography className={classes.heading}>Display Label</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className={classes.accordionDetails}>
                                                <Grid container={true} spacing={3}>
                                                    <Grid item={true} xs={12} md={12} lg={12} sm={12}>
                                                        <Field
                                                            name="personActingLabel"
                                                            subscription={{touched: true, error: true, value: true}}
                                                        >
                                                            {({ input, meta }) => (
                                                                <TextField
                                                                    {...input}
                                                                    label="Matter Working Responsibility Label"
                                                                    className={classes.textField}
                                                                    error={meta.error && meta.touched}
                                                                    helperText={
                                                                        meta.error && meta.touched
                                                                            ? 'Matter Working Responsibility Label is required.'
                                                                            : ''
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                    </Grid>
                                                    <Grid item={true} xs={12} md={12} lg={12} sm={12}>
                                                        <Field
                                                            name="personResponsibleLabel"
                                                            subscription={{touched: true, error: true, value: true}}
                                                        >
                                                            {({ input, meta }) => (
                                                                <TextField
                                                                    {...input}
                                                                    label="Matter Oversight Responsibility Label"
                                                                    className={classes.textField}
                                                                    error={meta.error && meta.touched}
                                                                    helperText={
                                                                        meta.error && meta.touched
                                                                            ? 'Matter Oversight Responsibility Label is required.'
                                                                            : ''
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                    </Grid>
                                                    <Grid item={true} xs={12} md={12} lg={12} sm={12}>
                                                        <Field
                                                            name="matterAssistingResponsibilityLabel"
                                                            subscription={{touched: true, error: true, value: true}}
                                                        >
                                                            {({ input, meta }) => (
                                                                <TextField
                                                                    {...input}
                                                                    label="Matter Assisting Responsibility Label"
                                                                    className={classes.textField}
                                                                    error={meta.error && meta.touched}
                                                                    helperText={
                                                                        meta.error && meta.touched
                                                                            ? 'Matter Assisting Responsibility Label is required.'
                                                                            : ''
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                    </Grid>
                                                    <Grid item={true} xs={12} md={12} lg={12} sm={12}>
                                                        <Field
                                                            name="matterIntroducingResponsibilityLabel"
                                                            subscription={{touched: true, error: true, value: true}}
                                                        >
                                                            {({ input, meta }) => (
                                                                <TextField
                                                                    {...input}
                                                                    label="Matter Introducing Responsibility Label"
                                                                    className={classes.textField}
                                                                    error={meta.error && meta.touched}
                                                                    helperText={
                                                                        meta.error && meta.touched
                                                                            ? 'Matter Introducing Responsibility Label is required.'
                                                                            : ''
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                    </Grid>
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                    <Grid item={true} xs={12} md={12}>
                                        <Accordion defaultExpanded={true} className={classes.accordionPanel}>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="mapping-settings-panel">
                                                <Typography className={classes.heading}>Mapping</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className={classes.accordionDetails}>
                                                <Grid container={true} spacing={3}>
                                                    <Grid item={true} xs={12} md={12} lg={12} sm={12}>
                                                        <Field
                                                            name="matterWorkingResponsibilityMapping"
                                                            subscription={{touched: true, error: true, value: true}}
                                                        >
                                                            {({ input, meta }) => (
                                                                <TextField
                                                                    {...input}
                                                                    label="Matter Working Responsibility Mapping"
                                                                    className={classes.textField}
                                                                    error={meta.error && meta.touched}
                                                                    helperText={
                                                                        meta.error && meta.touched
                                                                            ? 'Matter Working Responsibility Mapping is required.'
                                                                            : ''
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                    </Grid>
                                                    <Grid item={true} xs={12} md={12} lg={12} sm={12}>
                                                        <Field
                                                            name="matterOversightResponsibilityMapping"
                                                            subscription={{touched: true, error: true, value: true}}
                                                        >
                                                            {({ input, meta }) => (
                                                                <TextField
                                                                    {...input}
                                                                    label="Matter Oversight Responsibility Mapping"
                                                                    className={classes.textField}
                                                                    error={meta.error && meta.touched}
                                                                    helperText={
                                                                        meta.error && meta.touched
                                                                            ? 'Matter Oversight Responsibility Mapping is required.'
                                                                            : ''
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                    </Grid>
                                                    <Grid item={true} xs={12} md={12} lg={12} sm={12}>
                                                        <Field
                                                            name="matterAssistingResponsibilityMapping"
                                                            subscription={{touched: true, error: true, value: true}}
                                                        >
                                                            {({ input, meta }) => (
                                                                <TextField
                                                                    {...input}
                                                                    label="Matter Assisting Responsibility Mapping"
                                                                    className={classes.textField}
                                                                    error={meta.error && meta.touched}
                                                                    helperText={
                                                                        meta.error && meta.touched
                                                                            ? 'Matter Assisting Responsibility Mapping is required.'
                                                                            : ''
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                    </Grid>
                                                    <Grid item={true} xs={12} md={12} lg={12} sm={12}>
                                                        <Field
                                                            name="matterIntroducerResponsibilityMapping"
                                                            subscription={{touched: true, error: true, value: true}}
                                                        >
                                                            {({ input, meta }) => (
                                                                <TextField
                                                                    {...input}
                                                                    label="Matter Introducer Responsibility Mapping"
                                                                    className={classes.textField}
                                                                    error={meta.error && meta.touched}
                                                                    helperText={
                                                                        meta.error && meta.touched
                                                                            ? 'Matter Introducer Responsibility Mapping is required.'
                                                                            : ''
                                                                    }
                                                                />
                                                            )}
                                                        </Field>
                                                    </Grid>
                                                </Grid>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Grid>
                                    <Grid item={true} xs={12} md={12} justify="flex-end">
                                        <div className={classes.buttonWrapper}>
                                            <Button 
                                                variant="outlined" 
                                                color="primary"
                                                type="submit"
                                                disabled={submitting || pristine || state.onSubmitLoading}
                                            >
                                                Save
                                            </Button>
                                            <Button 
                                                variant="outlined" 
                                                color="primary"
                                                type="button"
                                                disabled={submitting || pristine}
                                                onClick={onReset(form)}
                                            >
                                                Reset
                                            </Button>
                                        </div>
                                    </Grid>
                                    {/* {printJson(values)} */}
                            </Grid>
                            </form>
                        )}
                />
            )}
        </div>
    );
}

// tslint:disable-next-line: no-any
export function printJson(values: any) {
    if (values) {
        return (
            <>
                <pre>
                    {JSON.stringify(values, undefined, 2)}
                </pre>
            </>
        );
    } else {
        return (
            <>
                <FormSpy subscription={{ values: true }}>
                    {/* tslint:disable-next-line: no-shadowed-variable */}
                    {({ values }) => (
                        <pre>
                            {JSON.stringify(values, undefined, 2)}
                            {/* <RenderCount /> */}
                        </pre>
                    )}
                </FormSpy>
            </>
        );
    }
}

interface LabelSettingsMutationParams {
    personActingLabel: string | null;
    personResponsibleLabel: string | null;
    matterAssistingResponsibilityLabel: string | null;
    matterIntroducingResponsibilityLabel: string | null;
    matterWorkingResponsibilityMapping: string | null;
    matterOversightResponsibilityMapping: string | null;
    matterAssistingResponsibilityMapping: string | null;
    matterIntroducerResponsibilityMapping: string | null;
}

const LabelSettingsMutation = gql`
    mutation UpdateLabelSettings (
        $personActingLabel: String, 
        $personResponsibleLabel: String,
        $matterAssistingResponsibilityLabel: String,
        $matterIntroducingResponsibilityLabel: String,
        $matterWorkingResponsibilityMapping: String,
        $matterOversightResponsibilityMapping: String,
        $matterAssistingResponsibilityMapping: String,
        $matterIntroducerResponsibilityMapping: String
    ){
        applicationSettings {
            labelSettings {
                update (
                    personActingLabel: $personActingLabel, 
                    personResponsibleLabel: $personResponsibleLabel,
                    matterAssistingResponsibilityLabel: $matterAssistingResponsibilityLabel,
                    matterIntroducingResponsibilityLabel: $matterIntroducingResponsibilityLabel,
                    matterWorkingResponsibilityMapping: $matterWorkingResponsibilityMapping,
                    matterOversightResponsibilityMapping: $matterOversightResponsibilityMapping,
                    matterAssistingResponsibilityMapping: $matterAssistingResponsibilityMapping,
                    matterIntroducerResponsibilityMapping: $matterIntroducerResponsibilityMapping
                ) {
                    error
                    status
                }
            }
        }
    }
`;